<!--Desktop Banner-->
<fgb-desktop-nav-banner [pageName]="'lotto.banner.title' | translate" [imageName]="'rewards'"></fgb-desktop-nav-banner>

<!--Mobile Navigation-->
<fgb-mobile-nav-menu [pageName]="'lotto.page.title' | translate"></fgb-mobile-nav-menu>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="bg-primary d-lg-none mobile-header-background"></div>
<div class="container pt-4 mobile-page-content">
  <fgbcl-lottos-list-v2 [isList]="true" [defaultSort]="1" />
</div>
